import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class DownTimeTrackingStatusResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
